import { BFF_RT_DISABLED_FARE_TOAST } from '@/constants/fareFamily'
import { DepartureTimeMapping } from '@/types/srp'

export const BRANDED_FARE_FAMILY = 'BRANDED_FARE_FAMILY'
export const DEMAND = 'DEMAND'

export const TRIP_TYPE = 'TRIP_TYPE'
export const DEPARTURE_CITY = 'DEPARTURE_CITY'
export const RETURN_CITY = 'RETURN_CITY'
export const ONWARD_DATE = 'ONWARD_DATE'
export const RETURN_DATE = 'RETURN_DATE'
export const TRAVELLERS = 'TRAVELLERS'
export const CALENDAR = 'CALENDAR'
export const ONEWAY_LABEL = 'One way'
export const ROUND_TRIP_LABEL = 'Round trip'
export const LOGGED_IN = 'LOGGED_IN'
export const NON_LOGGED_IN = 'NON_LOGGED_IN'
export const PER_ADULT_TEXT = 'per adult'
export const INTL_OW_PER_ADULT_TXT = '/Adult'
export const MORE_FARES_AVAILABLE = 'more fares available'
export const tripTypeOptions = [
    { key: 'OW', label: ONEWAY_LABEL },
    { key: 'RT', label: ROUND_TRIP_LABEL }
]
export const ONWARD = 'ONWARD'
export const RETURN = 'RETURN'
export const DEPARTURE = 'DEPARTURE'
export const TUPPLE_BOOK_BTN = 'Book'
export const FLIGHT_DETAILS_DONE_BTN = 'DONE'
export const TUPPLE_BOOK_BTN_FF = 'Book now'
export const SAME_CITY_ERROR = 'Departure and Arrival airports/cities cannot be same.'
export const FLIGHT_DETAILS_TEXT = 'Flight details'
export const TRIP_DETAILS_TEXT = 'Trip details'
export const REMOVE_FILTERS_TXT = 'Try removing some filters'
export const NON_STOP_FILTER_PRE_APPLIED_TXT = 'Non stop filter is pre-applied.'
export const NA_TXT = 'N/A'

export const NON_REFUNDABLE = 'NON_REFUNDABLE'
export const PARTIAL_REFUNDABLE = 'PARTIAL_REFUNDABLE'
export const AIRPORT_CHANGE = 'AIRPORT_CHANGE'
export const TRANSIT_VISA = 'TRANSIT_VISA'
export const HAND_BAGGAGE = 'HAND_BAGGAGE'
export const VISA_DENIAL_COVER = 'VISA_DENIAL_COVER'
export const VISA_REJECTION_COVER = 'VISA_REJECTION_COVER'
export const STUDENT_FARE_AVAILABLE = 'STUDENT_FARE_AVAILABLE'
export const STUDENT_FARE = 'STUDENT_FARE'
export const STUDENT_BADGE_TEXT = 'STUDENT'
export const ALLOWED_BENEFIT_TYPES = [PARTIAL_REFUNDABLE, VISA_REJECTION_COVER, AIRPORT_CHANGE, TRANSIT_VISA, NON_REFUNDABLE, HAND_BAGGAGE]
export const PTC_BENEFIT_TYPES = [STUDENT_FARE, STUDENT_FARE_AVAILABLE]
export const INTL_RT_CONTAINER_WIDTH = '1190px'

export const SRP_REVAMP_SHELL_WIDTH = '1280px'
export const SRP_REVAMP_SHELL_CSS = { maxWidth: SRP_REVAMP_SHELL_WIDTH, margin: 'auto' }
export const SRP_REVAMP_FILTER_RAIL_WIDTH = '288px'
export const SRP_REVAMP_FILTER_STICKY_TOP = 16
export const SRP_REVAMP_RESULTS_WIDTH = '912px'
export const SRP_REVAMP_SURFACE_BG = '#F3F5FA'
export const SRP_REVAMP_BAND_SHADOW = '0 2px 8px rgba(0, 0, 0, 0.08)'

/**
 * Control (pre-revamp) filter column, top to bottom. Keep as is: it is the revamp
 * experiment's control. Its entries also define the valid section keys.
 */
export const SRP_FILTER_ORDER_CONTROL = [
    'ctUpgrade',
    'totalRoundTripPrice',
    'ptcFare',
    'nearbyAirport',
    'stops',
    'visaRejection',
    'checkInBaggage',
    'airlines',
    'timings',
    'price',
    'duration',
    'layoverAirport'
] as const

export type SrpFilterSection = (typeof SRP_FILTER_ORDER_CONTROL)[number]

/** Revamp-only filter order per route type. To reorder one, give it its own array here. */
export const SRP_REVAMP_FILTER_ORDER: Record<'dom' | 'intl', readonly SrpFilterSection[]> = {
    dom: SRP_FILTER_ORDER_CONTROL,
    intl: SRP_FILTER_ORDER_CONTROL
}

export const SRP_REVAMP_FIELD_WIDTH = {
    tripType: 125,
    airport: 180,
    date: 140,
    travellers: 194
} as const

export const TOTAL_PRICE = 'Total price'
export const LOWEST_ROUNDTRIP_PRICE = 'Lowest roundtrip price'
export const SPECIAL_RETURN_PRICE = 'Special return price'
export const ONWARD_LABEL = 'Onward'
export const RETURN_LABEL = 'Return'
export const INTERSTITIAL_SPL_RT_LABEL = 'Select your round trip fare'
export const VIEW_TOTAL = 'View total'
export const FLIGHTS_AT_SAME_PRICE = 'Flights at same price'
export const HIDE = 'Hide'
export const HIDE_OPTIONS_WITH_SAME_PRICE = 'Hide options with same price'
export const SELECTED_SAME_PRICE_CARD = 'selectedSamePriceCard'
export const SELECTED_SAME_PRICE_CARD_LIST = 'selectedSamePriceCardList'
export const MULTIPLE_AIRLINES_TXT = 'Multiple Airlines'
export const INTL_ONEWAY_TUPPLE_WIDTH = '834px'
export const stopsInfoWidth = '88px'
export const cancellationChargesText = 'Airline Charges are per passenger, not guaranteed and are only indicative. All refunds are subject to airline approval.'
export const popularCities = [
    { k: 'BLR', v: 'Bengaluru, IN - Kempegowda International Airport (BLR)', pr: '' },
    { k: 'BOM', v: 'Mumbai, IN - Chatrapati Shivaji Airport (BOM)', pr: '' },
    { k: 'DEL', v: 'New Delhi, IN - Indira Gandhi Airport (DEL)', pr: '' },
    { k: 'CCU', v: 'Kolkata, IN - Netaji Subhas Chandra Bose Airport (CCU)', pr: '' },
    { k: 'GOI', v: 'Goa, IN - Dabolim Airport (GOI)', pr: '' },
    { k: 'HYD', v: 'Hyderabad, IN - Rajiv Gandhi International (HYD)', pr: '' },
    { k: 'MAA', v: 'Chennai, IN - Chennai Airport (MAA)', pr: '' }
]

export const SEARCH_NO_FLIGHTS_AVAILABLE = 'SEARCH_NO_FLIGHTS_AVAILABLE'
export const SEARCH_FLIGHT_SERVER_ERROR = 'SEARCH_FLIGHT_SERVER_ERROR'
export const DATE_ERROR = 'DATE_ERROR'
export const FARE_INCLUSIONS = {
    BAGGAGE: 'withBaggage',
  }

export const DEPARTURE_TIME_MAPPING_OBJ: DepartureTimeMapping = {
    '0000': {
        label: 'Early morning',
        subLabel: '12 AM - 8 AM',
        intlLabel: '12am_8am',
        value: '0000',
        time: {
            start: 0,
            end: 800
        }
    },
    '0800': {
        label: 'Morning',
        subLabel: '8 AM - 12 PM',
        intlLabel: '8am_12pm',
        value: '0800',
        time: {
            start: 800,
            end: 1200
        }
    },
    '1200': {
        label: 'Afternoon',
        subLabel: '12 PM - 4 PM',
        intlLabel: '12pm_4pm',
        value: '1200',
        time: {
            start: 1200,
            end: 1600
        }
    },
    '1600': {
        label: 'Evening',
        subLabel: '4 PM - 8 PM',
        intlLabel: '4pm_8pm',
        value: '1600',
        time: {
            start: 1600,
            end: 2000
        }
    },
    '2000': {
        label: 'Night',
        subLabel: '8 PM - 12 AM',
        intlLabel: '8pm_12am',
        value: '2000',
        time: {
            start: 2000,
            end: 2400
        }
    }
}

export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

type MonthConfig = Record<string, string>

export const monthConfig: MonthConfig = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
}

export const listOfJourneyKeys: ['J1', 'J2'] = ['J1', 'J2']
export const benefitListData = [
    {
        benefitDisplayName: 'Cancellation fee',
        benefitKey: 'CANCEL'
    },
    {
        benefitDisplayName: 'Date change fee',
        benefitKey: 'AMEND'
    },
    {
        benefitDisplayName: 'Seat selection',
        benefitKey: 'SEAT'
    },
    {
        benefitDisplayName: 'Meal selection',
        benefitKey: 'MEAL'
    },
    {
        benefitDisplayName: 'Cabin bag/adult',
        benefitKey: 'HAND_BAGGAGE'
    },
    {
        benefitDisplayName: 'Check-in bag/adult',
        benefitKey: 'CHECK_IN_BAGGAGE'
    },
    {
        benefitDisplayName: 'Visa Rejection Cover',
        benefitKey: 'VISA_REJECTION_COVER'
    }
]

export const filterTypes = {
    STOPS: 'stops',
    AIRLINE_FILTER: 'airlineFilter',
    DEPARTURE_TIME_FROM: 'departureTimeFrom',
    ARRIVAL_TIME_FROM: 'arrivalTimeFrom',
    NEARBY_AIRPORT: 'nearbyAirportFilter',
    TRIP_DURATION:'tripDuration',
    LAYOVER_DURATION: 'layoverDuration',
    CHECK_IN_BAGGAGE: 'checkInBaggage',
    LAYOVER_AIRPORT: 'layoverAirportFilter',
    ONE_WAY_PRICE:'oneWayPrice',
    CT_UPGRADE: 'ctUpgrade',
    TOTAL_ROUND_TRIP_PRICE: 'totalRoundTripPrice',
    VISA_REJECTION: 'visaRejection',
    PTC_FARE: 'ptcFare'
}

export const emiDataReqCount = {
    oneWay: 15,
    roundTrip: 10
}

export const STUDENT_FARE_TOAST_MESSAGE = 'Showing student + other low priced fares'
export const PTC_ERROR_MESSAGE = 'No student fares available. Showing regular fares with great value'
export const DISABLED_FARE_TOAST_MSG_BRANDED_FARE = {
    ONWARD: BFF_RT_DISABLED_FARE_TOAST.NON_CT_BRANDED,
    RETURN: BFF_RT_DISABLED_FARE_TOAST.CT_BRANDED
}
export const BRANDED_FARE_RETURN_TRIP_DESCRIPTION = 'To select a different fare please change your onward fare.'
export const BRANDED_FARE_HEADER_PREFIX = 'Enjoy benefits of'
export const ARRIVAL_DEPARTURE_OVERLAP_TIME = 0
export const ARRIVAL_DEPARTURE_THRESHOLD = 30
export const OVERLAP_ERROR_MESSAGE = 'Hey, these flights overlap, please change the selection'
export const THIRTY_MINS_OVERLAP_ERROR_MESSAGE =
    'Hey, these flights have less than 30 mins between departure/arrival time'
export const NOTE_WITH_COLON = 'NOTE:'
export const FARE_TYPE_COMMON_FOR_FULL_TRIP = 'Fare type is common for the full trip'
export const CLEARTIP_EXCLUSIVE = 'Cleartrip exclusive'
/** §9.4 — mirrors flights-pwa's CROSS_CABIN_SAME_TYPE_MESSAGE (constants/flights/fareCards.ts). */
export const CROSS_CABIN_SAME_TYPE_MESSAGE = 'Both onward and return fares must be of the same type.'
export const WOW_BADGE_SRC = 'https://storage.googleapis.com/staticresource-prod/images/logos/air-logos/svg_logos/wow-pricing/WowIconGreen.svg'
export const MESSAGE_SPLIT_PATTERN = /({wow}|{wowDisplayPrice}|<b>[^<]*<\/b>)/gi
export const WOW_LABEL_GRADIENT = 'linear-gradient(270deg, #ecf8f4 33.93%, rgba(236, 248, 244, 0) 72.67%)'

export const RT_MASTER_WOW_LOADING_ID = '__rt_master_wow__'
